import "./App.css";
import Quotes from "./Quotes";
import Loading from "./Loading";
import { arrRandomVal, backgroundColors } from "./utils";
import { useEffect, useState } from "react";

export const App = () => {
  const [quotes, setQuotes] = useState([]);
  const [color, setColor] = useState(backgroundColors[0]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const newBgColor = () => {
    setColor((prev) => {
      let next = arrRandomVal(backgroundColors);
      if (next === prev) return newBgColor();
      return next;
    });
  };

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      const { fetchQuotes } = await import("./utils");
      const data = await fetchQuotes();
      if (cancelled) return;
      if (data.length === 0) {
        setHasError(true);
      } else {
        setQuotes(data);
      }
      setIsLoaded(true);
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!isLoaded) return <Loading />;

  if (hasError || quotes.length === 0) {
    return (
      <div className="app-container" style={{ backgroundColor: color }}>
        <div className="error-state">
          <p className="error-eyebrow">Connection issue</p>
          <h1 className="error-title">We couldn't reach the library.</h1>
          <p className="error-body">
            Please check your connection and try again.
          </p>
          <button
            className="primary-button"
            onClick={() => window.location.reload()}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container" style={{ backgroundColor: color }}>
      <header className="app-header">
        <a className="brand" href="/">
          <span className="brand-mark" aria-hidden="true">
            Q
          </span>
          <span className="brand-name">Quotient</span>
        </a>
        <a
          className="header-github"
          href="https://github.com/Trefu"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub profile"
          title="github.com/Trefu"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.1.79-.25.79-.56v-2c-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.28-1.68-1.28-1.68-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.73-1.55-2.55-.29-5.23-1.28-5.23-5.69 0-1.26.45-2.29 1.18-3.1-.12-.29-.51-1.46.11-3.04 0 0 .96-.31 3.16 1.18a10.9 10.9 0 0 1 5.74 0c2.2-1.49 3.16-1.18 3.16-1.18.62 1.58.23 2.75.11 3.04.74.81 1.18 1.84 1.18 3.1 0 4.42-2.69 5.39-5.25 5.68.41.36.78 1.06.78 2.14v3.17c0 .31.21.67.8.55C20.21 21.39 23.5 17.08 23.5 12 23.5 5.65 18.35.5 12 .5z" />
          </svg>
        </a>
      </header>

      <main className="app-main">
        <Quotes quotes={quotes} newBgColor={newBgColor} />
      </main>

      <footer className="app-footer">
        <a
          className="github-link"
          href="https://github.com/Trefu"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub profile"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.1.79-.25.79-.56v-2c-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.28-1.68-1.28-1.68-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.73-1.55-2.55-.29-5.23-1.28-5.23-5.69 0-1.26.45-2.29 1.18-3.1-.12-.29-.51-1.46.11-3.04 0 0 .96-.31 3.16 1.18a10.9 10.9 0 0 1 5.74 0c2.2-1.49 3.16-1.18 3.16-1.18.62 1.58.23 2.75.11 3.04.74.81 1.18 1.84 1.18 3.1 0 4.42-2.69 5.39-5.25 5.68.41.36.78 1.06.78 2.14v3.17c0 .31.21.67.8.55C20.21 21.39 23.5 17.08 23.5 12 23.5 5.65 18.35.5 12 .5z" />
          </svg>
        </a>
      </footer>
    </div>
  );
};

export default App;
